// Mock data for Salón y Spa Saldívar Villar

export const salonInfo = {
  name: "Salón y Spa Saldívar Villar",
  tagline: "Tu momento de belleza, calma y renovación",
  subtitle: "Un espacio diseñado para consentirte por dentro y por fuera",
  whatsapp: "+527224802458",
  whatsappFormatted: "+52 722 480 24 58",
  logo: "https://customer-assets.emergentagent.com/job_2cd2b411-fb9d-403b-9526-8c164408c92a/artifacts/ehjm134d_LogoSaldivarVillar.jpg",
  social: {
    facebook: "https://www.facebook.com/share/1GCb8V4iQR/?mibextid=wwXIfr",
    instagram: "https://www.instagram.com/salonyspasaldivarvillar/"
  },
  hours: {
    weekdays: "Lunes a Viernes: 9:00 AM - 8:00 PM",
    saturday: "Sábado: 9:00 AM - 6:00 PM",
    sunday: "Domingo: Cerrado"
  }
};

export const promotion = {
  active: true,
  title: "¡Gran Apertura en Calimaya!",
  discount: "30%",
  description: "de descuento en todos los servicios",
  cta: "Reserva ahora",
  badge: "PRÓXIMAMENTE"
};

export const locations = [
  {
    id: 1,
    name: "Sucursal Toluca",
    address: "José Martí 151-1, Edificio NA, Interior Piso 1",
    colony: "Colonia Tlacopa, Estado de México",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3765.547!2d-99.6567!3d19.2833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDE2JzU5LjkiTiA5OcKwMzknMjQuMSJX!5e0!3m2!1ses!2smx!4v1234567890",
    available: true
  },
  {
    id: 2,
    name: "Sucursal Calimaya",
    address: "Próxima apertura",
    colony: "Calimaya, Estado de México",
    mapUrl: "",
    available: false
  }
];

export const services = [
  {
    category: "Spa & Relajación",
    icon: "Sparkles",
    items: [
      { name: "Masaje Relajante", description: "Libera tensiones y renueva tu energía con técnicas suaves", benefit: "Relajación profunda" },
      { name: "Masaje Descontracturante", description: "Alivia dolores musculares y mejora tu movilidad", benefit: "Alivio del dolor" },
      { name: "Aromaterapia", description: "Equilibra cuerpo y mente con aceites esenciales", benefit: "Bienestar integral" },
      { name: "Piedras Calientes", description: "Terapia ancestral para relajación muscular profunda", benefit: "Calma absoluta" }
    ]
  },
  {
    category: "Cabello",
    icon: "Scissors",
    items: [
      { name: "Corte de Cabello", description: "Cortes personalizados que realzan tu estilo único", benefit: "Imagen renovada" },
      { name: "Coloración", description: "Técnicas de color para un look vibrante y natural", benefit: "Color radiante" },
      { name: "Tratamientos Capilares", description: "Nutrición profunda para un cabello saludable", benefit: "Cabello sedoso" },
      { name: "Peinados", description: "Looks para eventos especiales y ocasiones únicas", benefit: "Elegancia total" },
      { name: "Alisado", description: "Cabello liso, suave y manejable por más tiempo", benefit: "Practicidad diaria" }
    ]
  },
  {
    category: "Manos y Pies",
    icon: "Hand",
    items: [
      { name: "Manicure Clásico", description: "Cuidado esencial para unas manos impecables", benefit: "Manos perfectas" },
      { name: "Manicure Spa", description: "Experiencia completa con exfoliación e hidratación", benefit: "Rejuvenecimiento" },
      { name: "Pedicure Clásico", description: "Cuidado profesional para pies saludables", benefit: "Pies renovados" },
      { name: "Pedicure Spa", description: "Tratamiento premium con masaje relajante", benefit: "Confort total" },
      { name: "Uñas Acrílicas", description: "Diseños personalizados y duraderos", benefit: "Estilo único" },
      { name: "Gelish", description: "Color brillante que dura semanas", benefit: "Brillo duradero" }
    ]
  },
  {
    category: "Estética Facial",
    icon: "Flower2",
    items: [
      { name: "Limpieza Facial Profunda", description: "Elimina impurezas y revitaliza tu piel", benefit: "Piel luminosa" },
      { name: "Tratamiento Anti-edad", description: "Combate líneas de expresión y devuelve firmeza", benefit: "Juventud renovada" },
      { name: "Hidratación Facial", description: "Nutrición intensiva para una piel radiante", benefit: "Hidratación profunda" },
      { name: "Diseño de Cejas", description: "Define tu mirada con precisión profesional", benefit: "Mirada perfecta" },
      { name: "Depilación Facial", description: "Piel suave con técnicas delicadas", benefit: "Suavidad total" }
    ]
  },
  {
    category: "Tratamientos Corporales",
    icon: "Leaf",
    items: [
      { name: "Exfoliación Corporal", description: "Renueva tu piel eliminando células muertas", benefit: "Piel renovada" },
      { name: "Envolturas Corporales", description: "Desintoxica y nutre con ingredientes naturales", benefit: "Desintoxicación" },
      { name: "Tratamiento Reductor", description: "Moldea tu figura con técnicas especializadas", benefit: "Silueta definida" },
      { name: "Depilación con Cera", description: "Piel suave y libre de vello por más tiempo", benefit: "Suavidad duradera" }
    ]
  }
];

export const benefits = [
  {
    icon: "Heart",
    title: "Atención Personalizada",
    description: "Cada tratamiento se adapta a tus necesidades únicas"
  },
  {
    icon: "Award",
    title: "Profesionales Certificados",
    description: "Equipo de expertos con formación continua"
  },
  {
    icon: "Gem",
    title: "Productos Premium",
    description: "Solo utilizamos productos de la más alta calidad"
  },
  {
    icon: "Shield",
    title: "Higiene Garantizada",
    description: "Protocolos estrictos de limpieza y desinfección"
  },
  {
    icon: "Sparkles",
    title: "Ambiente Relajante",
    description: "Un oasis de paz diseñado para tu bienestar"
  },
  {
    icon: "Clock",
    title: "Horarios Flexibles",
    description: "Nos adaptamos a tu ritmo de vida"
  }
];

export const aboutText = {
  title: "Tu santuario de belleza y bienestar",
  paragraphs: [
    "En Salón y Spa Saldívar Villar, creemos que cada persona merece momentos de paz y renovación. Somos más que un salón de belleza: somos un espacio donde el cuidado personal se convierte en una experiencia transformadora.",
    "Con años de experiencia y un equipo de profesionales apasionados, ofrecemos tratamientos que combinan técnicas tradicionales con las últimas tendencias en belleza y bienestar. Nuestro compromiso es brindarte un servicio excepcional en un ambiente cálido y elegante."
  ]
};
